/*
 Make multicolum cards clickable
 @todo hover events
 https://www.w3schools.com/howto/howto_js_accordion.asp
 */
document.addEventListener("DOMContentLoaded", function(arg) {
  var cards = document.getElementsByClassName("multicolumn-card");
  for (var i = 0; i < cards.length; i++) {
    var links = cards[i].getElementsByTagName('a');
	if (links.length != 1 || ! links[0].href) { continue; }
	cards[i].addEventListener("click", function() {
	  window.location.href = links[0].href;
    });
  }
});